export default "__VITE_ASSET__L$OVB_Ff__"